import { render } from "./NavigationTab.vue?vue&type=template&id=eede7f20&scoped=true&ts=true&lang=pug"
import script from "./NavigationTab.vue?vue&type=script&lang=ts"
export * from "./NavigationTab.vue?vue&type=script&lang=ts"

import "./NavigationTab.vue?vue&type=style&index=0&id=eede7f20&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eede7f20"]])

export default __exports__